import { AnyMxRecord } from 'dns';
import { forEach } from 'lodash';
import io from 'socket.io-client';
import { LoggerStatusEnum, sendLog } from 'ui-model';

import configService from '@lib/services/configService';

let socket: SocketIOClient.Socket;
let socketUserRegistered = false;

export function getSocket() {
  return socket;
}

export async function initiateSocket(userId: string) {
  const uri = `${configService.getApiSocketPath()}`;
  socket = io(uri, { transports: ['websocket'] });
  const socketLog = {
    connected: socket.connected,
    id: socket.id,
    uri: socket.io.uri,
  };
  return new Promise((resolve) => {
    socket.on('connect_error', (error: any) => {
      sendLog('Socket: connect_error', { socket: socketLog, error }, LoggerStatusEnum.error);
    });
    socket.on('connect_timeout', (timeout: any) => {
      sendLog(`Socket: connect_timeout (${timeout})`, { socket: socketLog }, LoggerStatusEnum.error);
    });
    socket.on('error', (error: any) => {
      sendLog('Socket: error', { socket: socketLog, error }, LoggerStatusEnum.error);
    });
    socket.on('reconnect_error', (error: any) => {
      sendLog('Socket: reconnect_error', { socket: socketLog, error }, LoggerStatusEnum.error);
    });
    socket.on('reconnect_failed', () => {
      sendLog('Socket: reconnect_failed', { socket: socketLog }, LoggerStatusEnum.error);
    });
    socket.on('reconnect', (attemptNumber: any) => {
      sendLog(`Socket: reconnect (${attemptNumber})`, { socket: socketLog }, LoggerStatusEnum.info);
    });
    socket.on('reconnect_attempt', (attemptNumber: any) => {
      sendLog(`Socket: reconnect_attempt (${attemptNumber})`, { socket: socketLog }, LoggerStatusEnum.info);
    });
    socket.on('reconnecting', (attemptNumber: any) => {
      sendLog('Socket: reconnecting', { socket: socketLog, attemptNumber }, LoggerStatusEnum.info);
    });
    socket.on('disconnect', (reason: any) => {
      if (reason === 'io server disconnect') {
        sendLog(`Socket: disconnect from server (${reason})`, { socket: socketLog }, LoggerStatusEnum.error);
        // Disconnection initiated by the server, try to reconnect
        socket.connect();
      } else {
        sendLog(`Socket: disconnect (${reason})`, { socket: socketLog }, LoggerStatusEnum.info);
      }
    });
    return socket.on('connect', () => {
      sendLog('Socket: connected', { socket: socketLog }, LoggerStatusEnum.info);
      // Register current user
      socket.emit('register', { id: userId, app: 'web-app' });
      sendLog(`Socket: user registered (${userId})`, { userId }, LoggerStatusEnum.info);
      socketUserRegistered = true;
      resolve(socket);
    });
  });
}

export function subscribeSocketEvents(events: string[], cb: (data: AnyMxRecord, cb?: Function) => void) {
  if (!socket || !socketUserRegistered) return false;
  sendLog(`Socket: subscribing to events...`, { events }, LoggerStatusEnum.info);

  forEach(events, (event) => {
    // Emit an initial event to signal the websocket will start receiving and sending events
    socket.emit('subscribe', event);
    socket.on(event, cb);
  });
  return true;
}

export function unsubscribeSocketEvents(events: string[], cb: (data: any, cb?: Function) => void) {
  if (!socket || !socketUserRegistered) return false;
  sendLog(`Socket: unsubscribing events...`, { events }, LoggerStatusEnum.info);

  forEach(events, (event) => {
    // Emit an initial event to signal the websocket will stop receiving and sending events
    socket.emit('unsubscribe', event);
    socket.off(event, cb);
  });
  return true;
}
